import React, { useEffect, useState } from "react";
import { ROUTES } from "../../../../constant/routeConstant";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { GROLOG_URL } from "../../../../constant/apiConstant";
import { AutoComplete, Input, Spin, Tooltip } from "antd";
import style from "../UOM.module.css";
import {
  AscRed,
  CloseIconSearch,
  DeleteIcon,
  DescGrey,
  DetailIcon,
  EditIcon,
  SearchIcon,
} from "../../../../asset";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import CustomTable from "../../../../component/table/CustomTable";
import CustomPaging from "../../../../component/pagination/pagination";
import { AddIcon } from "../../../../asset/icons";
import CustomDelete from "../../../../component/modal/CustomDelete";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import useDetailUOM from "../detail/detail-uom.hooks";
import { useSelector } from "react-redux";
import { disabledCategoryCode } from "../../../../util";

const ListUOM = () => {
  const { cekCategory } = useDetailUOM();
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [sorting, setSorting] = useState("category asc");
  const [sortingName, setSortingName] = useState("name asc");
  const [sortingCode, setSortingCode] = useState("code asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsfilter] = useState(false);

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async (page, limit, data, sort) => {
    setLoading(true);
    let res = await doGet(
      `/uom?page=${page}&limit=${limit}&order=${sort ? sort : sorting}${
        !isFilter
          ? ""
          : filter
          ? "&filter=name lk " + filter
          : data
          ? "&filter=name lk " + data
          : ""
      }&${param}`,
      token
    );
    let init = await doGet(
      `/uom/initiate?page=${page}&limit=${limit}&order=${
        sort ? sort : sorting
      }${
        !isFilter
          ? ""
          : filter
          ? "&filter=name lk " + filter
          : data
          ? "&filter=name lk " + data
          : ""
      }&${param}`,
      token
    );
    setListData(res?.data?.payload?.data);
    if (init?.data?.payload?.data) {
      setInitiate(init?.data?.payload?.data);
    } else {
    }
    setListData(res?.data?.payload?.data);
    setLoading(false);
    setFilter(false);
  };

  useEffect(() => {
    fetchData(page, limit);

    // eslint-disable-next-line
  }, [page, limit, data]);

  const handleEdit = (id) => {
    navigate(ROUTES.UOM.EDIT, { state: { id, prevPage: location?.pathname } });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.UOM.DETAIL, {
      state: { id, prevPage: location?.pathname },
    });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const dataSource = listData
    ? listData.map((result) => ({
        uom_id: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.uom_id ? result?.uom_id : "-"}
          </span>
        ),

        uom_category: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.uom_category ? cekCategory(result?.uom_category) : "-"}
          </span>
        ),
        uom_name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.uom_name ? result?.uom_name : "-"}
          </span>
        ),
        uom_category_code: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.uom_category_code ? result?.uom_category_code : "-"}
          </span>
        ),
        desc_uom: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.uom_description ? result?.uom_description : "-"}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button
                className={
                  disabledCategoryCode(result?.uom_category_code)
                    ? "cursor-not-allowed opacity-30"
                    : ""
                }
                onClick={() => handleEdit(result?.uom_id)}
                disabled={disabledCategoryCode(result?.uom_category_code)}
              >
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip>
            <Tooltip title={t("Delete")} color="#CF0000">
              <button
                className={
                  disabledCategoryCode(result?.uom_category_code)
                    ? "cursor-not-allowed opacity-30"
                    : ""
                }
                onClick={() => setModal(result)}
                disabled={disabledCategoryCode(result?.uom_category_code)}
              >
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip>

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleDetail(result?.uom_id)}>
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  const doSort = async (sort) => {
    setSorting(sort);

    if (sort) {
      setSorting(sort);
      fetchData(1, 10, data, sort);
    }
  };

  const doSortName = async (sort) => {
    setSortingName(sort);

    if (sort) {
      setSortingName(sort);
      fetchData(1, 10, data, sort);
    }
  };

  const doSortCode = async (sort) => {
    setSortingCode(sort);

    if (sort) {
      setSortingCode(sort);
      fetchData(1, 10, data, sort);
    }
  };

  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("UOM ID")}
        </span>
      ),
      dataIndex: "uom_id",
      key: "uom_id",
      render: (uom_id) => <span>{uom_id}</span>,
    },

    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("UOM Category")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "category asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={
                    sorting === "category asc"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("category asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "category asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={
                    sorting === "category asc"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("category desc");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "uom_category",
      key: "uom_category",
      render: (uom_category) => <span>{uom_category}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("UOM Name")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sortingName === "name asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={
                    sortingName === "name asc"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSortName("name asc");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sortingName === "name asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={
                    sortingName === "name asc"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSortName("name desc");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "uom_name",
      key: "uom_name",
      render: (uom_name) => <span>{uom_name}</span>,
    },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("UOM Category Code")}
            </span>
          </div>
        </div>
      ),
      dataIndex: "uom_category_code",
      key: "uom_category_code",
      render: (uom_category_code) => <span>{uom_category_code}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Description UOM")}
        </span>
      ),
      dataIndex: "desc_uom",
      key: "desc_uom",
      render: (desc_uom) => <span>{desc_uom}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("COMMON:ACTION")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    }
  };

  const fetchRecommendation = async (page, limit, filters) => {
    if (filters.length >= 1) {
      let res = await doGet(
        `/uom/search?page=${page}&limit=${limit}&filter=name lk ${filters}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true);
    setSearchRecommedation(value);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSelectRecommendation = (data) => {
    setIsfilter(true);
    setFilter(data);
    fetchData(1, 10, data);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    setPage(1);

    fetchData(1, 10, "");
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  return (
    <>
      <CustomDelete
        whihoutGrologAccount={true}
        data={data.updated_at}
        id={data.uom_id}
        delete={showDelete}
        title={data?.uom_name}
        url={"uom"}
        action={() => setShowDelete(false)}
        route={ROUTES.UOM.LIST}
        refresh={() => fetchData(1, 10, data)}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Unit Of Measurement`}
        />

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Units of Measurement")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <AutoComplete
            options={options}
            value={searchRecommendation}
            onChange={(value) => onSearchRecommendation(value)}
            onSelect={(value) => onSelectRecommendation(value)}
          >
            <Input
              placeholder={t("Search UOM Name")}
              className="w-[350px] h-[47px]"
              height={47}
              width={350}
              suffix={
                <img
                  src={searchRecommendation ? CloseIconSearch : SearchIcon}
                  alt="search"
                  onClick={
                    searchRecommendation ? () => onClearRecommendation() : null
                  }
                />
              }
              value={searchRecommendation}
            />
          </AutoComplete>
          <Link to={ROUTES.UOM.ADD}>
            <PrimaryButton text={t("Add UOM")} prefixIcon={<AddIcon />} />
          </Link>
        </div>

        {!loading ? (
          <div className={style.tableContainer}>
            <CustomTable columns={ListColumn} data={dataSource} />
            <div className={style.containerPagination + " mt-[-45px]"}>
              <CustomPaging
                idLimit="ddlrowsperpageuom"
                idPagination="btnpaginationuom"
                size="small"
                current={page}
                defaultCurrent={page}
                pageSize={limit}
                total={initiate && initiate?.count_data}
                pageSizeOptions={initiate && initiate?.valid_limit}
                onShowSizeChange={() => handlePagination()}
                handlePaging={(a, b) => handlePagination(a, b)}
                title={t("COMMON:ROW_PAGE")}
              />
            </div>
          </div>
        ) : (
          <Spin />
        )}
      </div>
    </>
  );
};

export default ListUOM;
